<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="13">
                <el-row>
                    <el-col>
                        <div class="spreadsheet-header-title">
                            {{ title }}
                        </div>
                        <div class="spreadsheet-header-filter-info">
                            <span class="spreadsheet-header-filter-info_black">
                                Поиск по:
                            </span>
                            <span class="spreadsheet-header-filter-info_gray">
                                {{ filterTitle }}
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <span class="spreadsheet-header-filter-info_black">
                            Всего найдено:
                        </span>
                        <span class="spreadsheet-header-filter-info_gray">
                            {{ pagesInfo.total }} приходов на сумму {{ pagesInfo.totalAmount }} р.
                        </span>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="2">
                <el-popover
                    popper-class="grid-search-dialog"
                    placement="top"
                    width="293"
                    trigger="click"
                    v-model="isFilterFormVisible"
                >
                    <el-button slot="reference" class="spreadsheet-header-button" type="warning">
                        поиск
                    </el-button>
                    <el-form label-position="top" @keyup.enter.native="filterApplied">
                        <el-form-item :label="fieldsNames.id" :label-width="formLabelWidth" v-if="isColumnVisible('id')">
                            <el-input v-model="filterModel.id" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.date" :label-width="formLabelWidth" v-if="isColumnVisible('date')">
                            <el-date-picker
                                v-model="filterModel.date"
                                type="daterange"
                                range-separator="по"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.operation_status_id" :label-width="formLabelWidth" v-if="isColumnVisible('operation_status_id')">
                            <el-select
                                v-model="filterModel.operation_status_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                                :placeholder="fieldsNames.operation_status_id"
                                size="mini"
                            >
                                <el-option v-for="item in operationStatusesList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.received_by_type" :label-width="formLabelWidth" v-if="isColumnVisible('received_by_id') && !isCashLess">
                            <el-select
                                v-model="filterModel.received_by_type"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                clearable
                                :placeholder="fieldsNames.received_by_type"
                                size="mini"
                            >
                                <el-option v-for="item in receivedByTypesList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.received_by_id" :label-width="formLabelWidth" v-if="isColumnVisible('received_by_id')">
                            <el-select
                                v-model="filterModel.received_by_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                filterable
                                multiple
                                collapse-tags
                                clearable
                                autocomplete
                                :placeholder="fieldsNames.received_by_id"
                                size="mini"
                            >
                                <el-option v-for="item in receivedByIdList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.received_from_type" :label-width="formLabelWidth" v-if="isColumnVisible('received_from_id') && !isCashLess">
                            <el-select
                                v-model="filterModel.received_from_type"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                clearable
                                :placeholder="fieldsNames.received_from_type"
                                size="mini"
                            >
                                <el-option v-for="item in receivedFromTypesList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.received_from_id" :label-width="formLabelWidth" v-if="isColumnVisible('received_from_id')">
                            <el-select
                                v-model="filterModel.received_from_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                filterable
                                multiple
                                collapse-tags
                                clearable
                                remote
                                reserve-keyword
                                :remote-method="searchReceivedFrom"
                                :placeholder="fieldsNames.received_from_id"
                                size="mini"
                            >
                                <el-option v-for="(item, index) in receivedFromIdList" :key="item.id + index" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.pay_type_id" :label-width="formLabelWidth" v-if="isColumnVisible('pay_type_id') && isPayTypeFilterVisible">
                            <el-select
                                v-model="filterModel.pay_type_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                                :placeholder="fieldsNames.pay_type_id"
                                size="mini"
                            >
                                <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.detail_id" :label-width="formLabelWidth" v-if="isColumnVisible('detail_id')">
                            <el-select
                                v-model="filterModel.detail_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                                :placeholder="fieldsNames.detail_id"
                                size="mini"
                            >
                                <el-option v-for="item in detailsList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.amount" :label-width="formLabelWidth" v-if="isColumnVisible('amount')">
                            <el-input v-model="filterModel.amount" autocomplete="on" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.comment" :label-width="formLabelWidth" v-if="isColumnVisible('comment')">
                            <el-input v-model="filterModel.comment" autocomplete="on" size="mini" clearable />
                        </el-form-item>
                    </el-form>
                    <div class="popover-footer">
                        <el-button @click="hideFilterForm">
                            Отменить
                        </el-button>
                        <el-button type="warning" @click="filterApplied">
                            Применить
                        </el-button>
                    </div>
                </el-popover>
            </el-col>
            <el-col :span="3">
                <span class="spreadsheet-header-total">
                    Всего записей: {{ pagesInfo.total }}
                </span>
            </el-col>
            <el-col :span="3">
                <el-button class="spreadsheet-header-button" type="warning" @click="goNewCard" v-if="headerOptions.isNewButtonVisible && canCreateIncome">
                    новый приход
                </el-button>
            </el-col>
            <el-col :span="1" title="Excel" class="icon-excel" v-if="isExcelButtonVisible">
                <div class="spreadsheet-header-excel">
                    &nbsp;
                </div>
            </el-col>
        </el-row>
        <el-row type="flex" align="top" class="spreadsheet-table" v-loading="loading">
            <el-col :span="24">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                />
            </el-col>
        </el-row>
        <el-row type="flex" align="bottom" class="spreadsheet-bar">
            <el-col :span="6">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :small="true"
                    @current-change="getCurrentPage"
                />
            </el-col>
            <el-col :span="10">
                <div class="spreadsheet-bar-pages">
                    <span class="spreadsheet-bar-pages-title">
                        Выводить по:
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize20}"
                        @click="setPageSize(20)"
                    >
                        20
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize50}"
                        @click="setPageSize(50)"
                    >
                        50
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize100}"
                        @click="setPageSize(100)"
                    >
                        100
                    </span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="spreadsheet-bar-total">
                    <span>
                        Строк выведено: {{ totalRows }} Из них выделено: {{ selectedRowsCount }}
                    </span>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import IncomeMixin from '@/mixins/income';
import { AgGridVue } from 'ag-grid-vue';
import TableHeaderSettings from '@/components/TableHeaderSettings';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import capitalize from 'lodash/capitalize';
import '@/assets/styles/list.scss';

library.add(faEye);

export default {
    name: 'IncomesBasGrid',
    mixins: [
        IncomeMixin
    ],
    data() {
        return {
            title: 'Список приходов',
            isFilterFormVisible: false,
            headerOptions: {
                isNewButtonVisible: false
            },
            settingName: 'incomes',
            isPayTypeFilterVisible: true,
            filterModel: {
                id: null,
                created_at: [],
                date: [],
                operation_type_id: [],
                operation_status_id: [],
                received_by_id: [],
                received_by_type: null,
                received_from_id: [],
                received_from_type: null,
                pay_type_id: [],
                detail_id: [],
                amount: null,
                deal_id: null,
                comment: null
            },
            fieldsNames: {
                id: 'id',
                created_at: 'дата создания',
                date: 'дата прихода',
                operation_type_id: 'тип операции',
                operation_status_id: 'статус операции',
                received_by_type: 'принял - тип контрагента',
                received_by_id: 'принял',
                received_from_type: 'получено у - тип контрагента',
                received_from_id: 'получено у',
                pay_type_id: 'вид оплаты',
                detail_id: 'статья',
                amount: 'сумма',
                deal_id: 'сделка',
                deal_contract: 'номер договора',
                comment: 'комментарий'

            },
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            formLabelWidth: '120px',
            totalRows: 0,
            selectedRowsCount: 0,
            loading: true,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onRowDataChanged: this.onRowDataChanged.bind(this),
                onRowSelected: this.onRowSelected.bind(this),
                onColumnResized: this.onColumnResized.bind(this),
                onDisplayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
                onRowDoubleClicked: this.onSelectionChanged.bind(this),
                onSortChanged: this.onSortChanged.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                }
            },
            columnDefs: [],
            cashPayTypes: [],
            cashlessPayTypes: [],
            isCashLess: false
        };
    },
    components: {
        AgGridVue
    },
    computed: {
        incomes() {
            return this.$store.state.incomes.incomes;
        },
        pagesInfo() {
            return this.$store.state.incomes.pages;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        receivedByIdList() {
            if (this.receivedByType === 'cash') {
                return this.cashesList;
            }
            if (this.receivedByType === 'employer') {
                return this.employersList;
            }
            if (this.receivedByType === 'factory') {
                return this.factoriesList;
            }
            return [];
        },
        receivedByType() {
            return this.filterModel.received_by_type;
        },
        receivedFromType() {
            return this.filterModel.received_from_type;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field]) {
                    if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                        switch (field) {
                            case 'received_by_id':
                                result += this.getNames(this.receivedByIdList, field);
                                break;
                            case 'received_from_id':
                                result += this.getNames(this.receivedFromIdList, field);
                                break;
                            case 'pay_type_id':
                                result += this.getNames(this.payTypesList, field);
                                break;
                            case 'detail_id':
                                result += this.getNames(this.detailsList, field);
                                break;
                            case 'operation_status_id':
                                result += this.getNames(this.operationStatusesList, field);
                                break;
                            case 'received_by_type':
                                result += this.getOneName(this.receivedByTypesList, field);
                                break;
                            case 'received_from_type':
                                result += this.getOneName(this.receivedFromTypesList, field);
                                break;
                            case 'created_at':
                            case 'date':
                                result += `${this.fieldsNames[field]}: c ${this.filterModel[field][0]}
                                 по ${this.filterModel[field][1]}; `;
                                break;
                            default:
                                result += `${this.fieldsNames[field]}: ${this.filterModel[field]}; `;
                        }
                    }
                }
            }
            return result;
        },
        isExcelButtonVisible() {
            //использовать в задаче реализации экспорта в excel
            return false;
        },
        canCreateIncome() {
            return false;
        }
    },
    created() {
        this.cashPayTypes = this.localReferences.payTypesFullCash;
        this.cashlessPayTypes = this.localReferences.payTypesFullCashless;
        this.columnDefs = [
            {
                headerName: this.capitalize(this.fieldsNames.id),
                field: 'id'
            },
            {
                headerName: this.capitalize(this.fieldsNames.created_at),
                field: 'created_at'
            },
            {
                headerName: this.capitalize(this.fieldsNames.date),
                field: 'date'
            },
            {
                headerName: this.capitalize(this.fieldsNames.operation_status_id),
                field: 'operation_status_id',
                cellRenderer: ({ data }) => data.operation_status_name
            },
            {
                headerName: this.capitalize(this.fieldsNames.received_by_id),
                field: 'received_by_id',
                cellRenderer: ({ data }) => data.received_by_name
            },
            {
                headerName: this.capitalize(this.fieldsNames.received_from_id),
                field: 'received_from_id',
                cellRenderer: ({ data }) => data.received_from_id ? data.received_from_name : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.pay_type_id),
                field: 'pay_type_id',
                cellRenderer: ({ data }) => data.pay_type_id ? data.pay_type_name : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.detail_id),
                field: 'detail_id',
                cellRenderer: ({ data }) => data.detail_id ? data.detail_name : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.amount),
                field: 'amount',
                cellRenderer: ({ data }) => data.amount_formatted
            },
            {
                headerName: this.capitalize(this.fieldsNames.deal_id),
                field: 'deal_id',
                cellRenderer: ({ data }) => {
                    return this.getLinkElement(data.deal_id, data.deal_id, { name: 'deal-card', params: { id: '' + data.deal_id } }, 'a', 'spreadsheet-table-id-link');
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.deal_contract),
                field: 'deal_id',
                cellRenderer: ({ data }) => {
                    if (data.deal && data.deal.contract_number && data.deal.contract_date) {
                        return `${data.deal.contract_number} от ${data.deal.contract_date}`;
                    }
                    return '';
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.comment),
                field: 'comment'
            },
            {
                headerName: '',
                field: '',
                headerComponentFramework: TableHeaderSettings,
                cellRenderer: ({ data }) => {
                    return this.getLinkElement(data.id, '', this.getRouteForCard(data), 'div', 'cell-icon');
                },
                width: 40,
                cellClass: null
            }
        ];
    },
    mounted() {
        this.loadSettings();
    },
    methods: {
        loadSettings() {
            this.$store.dispatch('preferences/getPreferences').then(
                () => {
                    this.setSettings();
                }).catch(() => {
                this.getDataFromServer();
            });
        },
        setSettings() {
            const settings = this.setting[this.settingName];
            if (settings) {
                this.gridOptions.columnApi.setColumnState(settings.table);
                this.gridOptions.api.setSortModel(settings.sort);
                this.filterModel = JSON.parse(JSON.stringify(settings.filter));
                this.pageModel = JSON.parse(JSON.stringify(settings.page));
            } else {
                this.gridOptions.api.setSortModel({});
            }
        },
        hideFilterForm() {
            this.isFilterFormVisible = false;
        },
        getLinkElement(id, name, route, elementType, className) {
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
            }
            element.innerText = name;
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        getRouteForCard(data) {
            const params = { id: '' + data.id };
            if (this.cashPayTypes.includes(data.pay_type_id)) {
                return { name: 'income-cash-card-view', params };
            }
            if (this.cashlessPayTypes.includes(data.pay_type_id)) {
                return { name: 'income-cashless-card-view', params };
            }
        },
        onSelectionChanged(e) {
            this.$router.push(this.getRouteForCard(e.node.data));
        },
        getDataFromServer() {
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: this.gridOptions.api.getSortModel(),
                filter: this.filterModel
            };
            this.loading = true;
            this.$store.dispatch('incomes/getPaginatedList', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(this.incomes);
                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;
                    this.saveSetting();
                }).finally(() => {
                this.loading = false;
            });
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        goNewCard() {
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        onRowDataChanged() {
            this.totalRows = this.gridOptions.api.getDisplayedRowCount();
        },
        onRowSelected() {
            this.selectedRowsCount = this.gridOptions.api.getSelectedRows().length;
        },
        isColumnVisible(colId) {
            return this.isFilterFormVisible && this.gridOptions.columnApi ? this.gridOptions.columnApi.getColumn(colId).visible : false;
        },
        onDisplayedColumnsChanged() {
            this.saveSetting();
        },
        onColumnResized(data) {
            if (data.finished && data.source === 'uiColumnDragged') {
                this.saveSetting();
            }
        },
        onSortChanged() {
            this.getDataFromServer();
        },
        async saveSetting() {
            const data = {};
            data[this.settingName] = {
                'table': this.gridOptions.columnApi.getColumnState(),
                'sort': this.gridOptions.api.getSortModel(),
                'filter': this.filterModel,
                'page': this.pageModel
            };
            await this.$store.dispatch('preferences/setPreferences', data);
        },
        capitalize,
        getNames(obj, field) {
            if (Object.keys(obj).length !== 0) {
                return `${this.fieldsNames[field]}: ${this.filterModel[field].map(id => obj.find(item => item.id === id).name).join(' | ')}; `;
            }
            return '';
        },
        getOneName(obj, field) {
            if (Object.keys(obj).length !== 0) {
                return `${this.fieldsNames[field]}: ${obj.filter(item => item.id === this.filterModel[field]).map(item => item.name).join('')}; `;
            }
            return '';
        }
    },
    watch: {
        receivedByType(value) {
            if (value && value.length) {
                this.filterModel.received_by_id = [];
            }
        },
        receivedFromType(value) {
            if (value && value.length) {
                this.filterModel.received_from_id = [];
                this.receivedFromIdList = [];
            }
        }
    }
};
</script>
